var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("repositories", { attrs: { type: "HEX", header: _vm.header } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }